import { ApiBookedItem, ApiHotelRoom, ApiRoomRate } from '@ibe/api';
import { sanitize } from '@ibe/services';
import React, { JSX } from 'react';
import Dates from '../Dates';
import { Price } from '../../Components/UI/Price/Price';

interface HotelContentItemProps {
  bookedItem: ApiBookedItem;
  room: ApiHotelRoom;
  rate: ApiRoomRate;
}

const HotelContentItem = (hotelContentItemProps: HotelContentItemProps): JSX.Element => {
  const { bookedItem, room, rate } = hotelContentItemProps;

  return (
    <div className="align-items-center justify-content-between w-100">
      <div>
        <div dangerouslySetInnerHTML={{ __html: sanitize(bookedItem.name) }} />
        <Dates item={bookedItem} />
        <div
          dangerouslySetInnerHTML={{
            __html: sanitize(room.name)
          }}
        />
        <div>{rate.mealTypeDescription}</div>
      </div>
      <div>
        <div className="d-flex align-items-center justify-content-end">
          {bookedItem.price && bookedItem.price.finalPrice > 0 && (
            <Price price={bookedItem.price} />
          )}
        </div>
      </div>
    </div>
  );
};
export default HotelContentItem;
